import { IconName } from '../Icon'

export interface IAppRoute {
  path: string
  name: string
  icon: IconName
}

export const routes: IAppRoute[] = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'dashboard',
  },
  {
    path: '/profile',
    name: 'Profile',
    icon: 'user',
  },
  // {
  //   path: "/ambassador-dashboard",
  //   name: "Campus Ambassador",
  //   icon: "tag",
  // },
]
